import packageInfo from '../../package.json';
export const environment = {
  production: true,
  version: packageInfo.version,
  apiServerUrl: 'https://service.avpark.ch',
  syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfcnRTRmZcUUJ0VkJWYE4=',

  mapbox: {
    accessToken: 'pk.eyJ1IjoiYXZlbnRpdCIsImEiOiJjbTB3NTNhc3MwMGxoMmtyMThzMzB3Nnh6In0.eF_A9YXMEXYMgsJoXQgWBg'
  },

  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.aventit.avpark',
  appStoreUrl: 'https://apps.apple.com/ch/app/av-park/id6741530814?l=en',

  apiClientId: 'AveParkWeb',
  localStorageToken: 'token',
  localStorageRefreshToken: 'refreshToken',
  localStorageUserInfo: 'userInfo',
  localStorageIsSidebarPinned: 'isSidebarPinned',
  localStorageAnonymousLanguage: 'anonymousLanguage',
  supportedLanguages: 'en,de,fr,it',
  alarmReloadInterval: 2000,
  idleTimeoutInSeconds: 300,
  localStorageActivityTimestamp: 'activityTimestamp',
  allowBrowserTranslation: true,
  envInfoClass: null // 'dev-env', 'test-env', empty or null for prod and test-help
};
